export default __webpack_public_path__ + "static/media/photo--lg--134.cc5330a8.jpg";